import { Component, inject, Input, OnChanges, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { PrescriptionFormService } from '../../services/prescription-form.service';
import { TuiPagination } from '@taiga-ui/kit';
import { AsyncPipe } from '@angular/common';
import { TuiTable } from '@taiga-ui/addon-table';
import { PrescriptionFormRowComponent } from '../prescription-form-row/prescription-form-row.component';
import { PrescriptionFormList } from '../../models/prescriptionForm/prescriptionForm';

@Component({
  selector: 'app-prescription-form-list',
  standalone: true,
  imports: [TuiTable, AsyncPipe, TuiPagination, PrescriptionFormRowComponent],
  templateUrl: './prescription-form-list.component.html',
  styleUrl: './prescription-form-list.component.scss',
})
export class PrescriptionFormListComponent implements OnInit, OnChanges {
  @Input() nomPrenom: string | undefined;
  @Input() nir: string | undefined;

  private readonly prescriptionService = inject(PrescriptionFormService);

  protected length = 1000;

  public prescriptionFormList$!: Observable<PrescriptionFormList>;

  changementDePage(page: number) {
    this.prescriptionFormList$ = this.prescriptionService.pullList(
      this.nir,
      this.nomPrenom,
      undefined,
      page + 1,
      15,
    );
  }

  ngOnInit(): void {
    this.prescriptionFormList$ = this.prescriptionService.pullList(
      this.nir,
      this.nomPrenom,
      undefined,
      1,
      15,
    );
  }

  ngOnChanges(): void {
    this.prescriptionFormList$ = this.prescriptionService.pullList(
      this.nir,
      this.nomPrenom,
      undefined,
      1,
      15,
    );
  }
}
